import type { IFavoriteSocial } from "../../hooks/http/admin/favorites/get-all-favorites.admin.http";
import type { IAssetMinimal } from "./asset.models.types";
import type { IBrandMinimal } from "./brands.models.types";
import type { ICampaignMetrics } from "./campaign-metrics.types";
import type { IGenreMinimal } from "./genre.models.types";
import type { ILocationMinimal } from "./location.models.types";
import type {
	SocialCreatorType,
	SocialGender,
	SocialPlatforms,
} from "./social.models.types";

export enum CampaignPlatform {
	SOLO = "solo",
	MEMED = "memed",
}

export enum CampaignStatus {
	archive = "archive",
	brandDraft = "brandDraft",
	adminDraft = "adminDraft",
	viewValidation = "viewValidation",
	live = "live",
	ended = "ended",
}

export enum SocialPostType {
	REEL = "reel",
	YOUTUBE_SHORT = "youtube_short",
	YOUTUBE_VIDEO = "youtube_video",
}

export enum MilestoneType {
	VIEWS = "views",
	LIKES = "likes",
}

export interface ICampaignStatus {
	status: CampaignStatus;
	message: string | null;
	timestamp: Date;
}

export interface Milestone {
	count: number;
	payout: number;
}

export interface ILinks {
	title: string;
	url: string;
}

export interface IProductRefund {
	image: IAssetMinimal;
	link: string | null;
	couponCode: string | null;
	refundAmount: number | null;
}

export interface ICampaignMinimal {
	id: string;
	brand: IBrandMinimal;
	name: string;
	campaignStatus: ICampaignStatus;
	favouriteSocial: IFavoriteSocial | null;
	coverImage: IAssetMinimal | null;
	socialPlatform: SocialPlatforms;
	socialPostType: SocialPostType;
	socialCreatorType: SocialCreatorType;
	startDate: Date | null;
	endDate: Date | null;
	budget: number | null;
	budgetInternal: number | null;
	minimumFollowers: number | null;
	maximumFollowers: number | null | undefined;
	locationPreference: Array<ILocationMinimal> | null;
	genre: Array<IGenreMinimal> | null;
	genderPreference: SocialGender | null;
	hashtags: string | null;
	mentions: string | null;
	aboutCampaign: string | null;
	aboutBrand: string | null;
	do: string | null;
	dont: string | null;
	aboutPayment: string | null;
	milestoneType: MilestoneType | null;
	productRefund: IProductRefund | null;
	hasFixedPayout: boolean;
	milestones: Array<Milestone> | null;
	links: Array<ILinks>;
	milestoneHasRefund: boolean;
	assets: Array<IAssetMinimal>;
	sampleVideos: Array<IAssetMinimal>;
	briefVideos: Array<IAssetMinimal>;
	metrics: ICampaignMetrics | null;
	metricsUpdatedAt: Date | null;
	dmsCampaign: {
		campaignId: string | null;
	};
}

export interface ICampaign extends ICampaignMinimal {}
